import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	height: 100%;
	align-items: center;
	width: 300px;
`;

export const Icon = styled.img`
	height: 35px;

	@media (max-width: 1200px) {
		height: 29px;
	}

	@media (max-width: 992px) {
		height: 26px;
	}

	@media (max-width: 768px) {
		height: 23px;
	}

	@media (max-width: 600px) {
		height: 21px;
	}
`;

export const ContentButton = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 30px;

	padding-top: 35px;
`;

export const RadioContainer = styled.div`
	display: flex;
	align-items: center;
	padding-left: 14px;
	width: 100%;

	padding-top: 10px;

	label {
		cursor: pointer;
	}
`;
